import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "@/App.css";
import { ThemeContext } from "@/lib/theme";
import { LanguageProvider } from "@/lib/i18n";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import WorldRhubarbDay from "@/pages/WorldRhubarbDay";
import Transparency from "@/pages/Transparency";
import Admin from "@/pages/Admin";
import DatabaseSurvey from "@/pages/DatabaseSurvey";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Verified from "@/pages/Verified";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [dark, setDark] = useState(() => localStorage.getItem("wra-theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("wra-theme", dark ? "dark" : "light");
  }, [dark]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <ThemeContext.Provider value={{ dark, toggle: () => setDark((d) => !d) }}>
        <LanguageProvider>
          <BrowserRouter>
            <ScrollManager />
            <div className="grain min-h-screen bg-background text-foreground">
              <Nav />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/world-rhubarb-day" element={<WorldRhubarbDay />} />
                <Route path="/transparency" element={<Transparency />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/database-survey" element={<DatabaseSurvey />} />
                <Route path="/verify" element={<Verified />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
              <Footer />
            </div>
            <Toaster position="bottom-center" />
          </BrowserRouter>
        </LanguageProvider>
      </ThemeContext.Provider>
    </HelmetProvider>
  );
}

export default App;
